var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4866,
    cy: 10.7449,
    r: 10.4919,
    fill: "#F5F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01685 15.3745L6.24122 15.9914L6.85814 13.2158C6.45186 12.4559 6.23992 11.6072 6.24122 10.7455C6.24122 7.84813 8.58983 5.49951 11.4872 5.49951C14.3845 5.49951 16.7331 7.84813 16.7331 10.7455C16.7331 13.6428 14.3845 15.9914 11.4872 15.9914C10.6255 15.9927 9.77679 15.7808 9.01685 15.3745ZM9.16899 14.266L9.51155 14.4496C10.1193 14.7744 10.7981 14.9437 11.4872 14.9422C12.3172 14.9422 13.1286 14.6961 13.8188 14.235C14.5089 13.7738 15.0468 13.1184 15.3645 12.3515C15.6821 11.5846 15.7652 10.7408 15.6033 9.92672C15.4414 9.11263 15.0417 8.36484 14.4547 7.77791C13.8678 7.19098 13.12 6.79128 12.3059 6.62934C11.4918 6.46741 10.648 6.55052 9.88114 6.86816C9.11428 7.18581 8.45884 7.72372 7.99769 8.41387C7.53655 9.10403 7.29041 9.91543 7.29041 10.7455C7.29041 11.4453 7.4609 12.1189 7.78353 12.7211L7.96661 13.0637L7.623 14.6096L9.16899 14.266ZM8.8642 10.7455H9.91339C9.91339 11.1629 10.0792 11.5632 10.3743 11.8583C10.6695 12.1535 11.0698 12.3193 11.4872 12.3193C11.9046 12.3193 12.3049 12.1535 12.6 11.8583C12.8952 11.5632 13.061 11.1629 13.061 10.7455H14.1102C14.1102 11.4411 13.8338 12.1083 13.3419 12.6002C12.85 13.0921 12.1828 13.3685 11.4872 13.3685C10.7915 13.3685 10.1244 13.0921 9.63245 12.6002C9.14055 12.1083 8.8642 11.4411 8.8642 10.7455Z",
    fill: "#7E8392"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5903,
    height: 12.5903,
    fill: "white",
    transform: "translate(5.19141 4.45068)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessChat);
export default __webpack_public_path__ + "static/media/business_chat.98e6b25be17cec859fa055911789922d.svg";
export { ForwardRef as ReactComponent };